import type { RiskLevel } from '../../api/bindings/RiskLevel.ts';
import { inputClass } from '../AuthCard.tsx';
import type { EditProps, ViewProps } from './types.ts';

const LEVEL_STYLES: Record<RiskLevel, string> = {
  low: 'bg-green-50 text-green-700',
  medium: 'bg-amber-50 text-amber-700',
  high: 'bg-red-50 text-red-700',
};

export function RiskListView({ content }: ViewProps<'risk_list'>) {
  if (content.items.length === 0) return null;
  return (
    <ul className="space-y-2">
      {content.items.map((item, i) => (
        <li key={i} className="flex break-inside-avoid items-baseline gap-3 text-sm">
          <span className={`rounded-full px-2 py-0.5 text-xs font-medium ${LEVEL_STYLES[item.level]}`}>
            {item.level}
          </span>
          <span className="font-medium text-gray-800">{item.category}</span>
          <span className="text-gray-600">{item.note}</span>
        </li>
      ))}
    </ul>
  );
}

export function RiskListEdit({ content, onChange }: EditProps<'risk_list'>) {
  const setItem = (i: number, patch: Partial<(typeof content.items)[number]>) =>
    onChange({
      ...content,
      items: content.items.map((item, j) => (j === i ? { ...item, ...patch } : item)),
    });
  return (
    <div className="space-y-2">
      {content.items.map((item, i) => (
        <div key={i} className="flex gap-2">
          <input
            className={inputClass}
            placeholder="Category"
            value={item.category}
            onChange={(e) => setItem(i, { category: e.target.value })}
          />
          <select
            className="rounded-md border border-gray-300 px-2 py-2 text-sm"
            value={item.level}
            onChange={(e) => setItem(i, { level: e.target.value as RiskLevel })}
          >
            <option value="low">low</option>
            <option value="medium">medium</option>
            <option value="high">high</option>
          </select>
          <input
            className={inputClass}
            placeholder="Risk and mitigation"
            value={item.note}
            onChange={(e) => setItem(i, { note: e.target.value })}
          />
          <button
            type="button"
            className="text-sm whitespace-nowrap text-red-500 hover:underline"
            onClick={() => onChange({ ...content, items: content.items.filter((_, j) => j !== i) })}
          >
            Remove
          </button>
        </div>
      ))}
      <button
        type="button"
        className="text-sm text-blue-600 hover:underline"
        onClick={() =>
          onChange({
            ...content,
            items: [...content.items, { category: '', level: 'medium', note: '' }],
          })
        }
      >
        Add risk
      </button>
    </div>
  );
}
